import { useEffect, useState } from "react";
import logoMinatomachi from "../../../assets/logo-minatomachi.png";
import { STORE } from "../../../data/storeData";

const links = [
  { href: "#menu", label: "メニュー" },
  { href: "#concept", label: "コンセプト" },
  { href: "#feature", label: "こだわり" },
  { href: "#store", label: "店舗情報" },
  { href: "#gift", label: "プレゼント" },
  { href: "#news", label: "お知らせ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
          <img
            src={logoMinatomachi}
            alt="KOBE ミナトマチカレー"
            className="h-9 md:h-12 w-auto"
            style={
              scrolled
                ? undefined
                : { filter: "drop-shadow(0 0 1.5px rgba(255,255,255,1)) drop-shadow(0 0 1.5px rgba(255,255,255,1)) drop-shadow(0 0 3px rgba(255,255,255,0.95)) drop-shadow(0 2px 4px rgba(0,0,0,0.35))" }
            }
          />
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`text-sm font-heading font-bold whitespace-nowrap cursor-pointer transition-colors hover:text-primary-600 ${
                scrolled ? "text-foreground-900" : "text-background-50 drop-shadow"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {/* 主要CTA（3つに集約）: メニュー / Googleマップ / 店舗情報 */}
          <a
            href="#menu"
            className="hidden lg:inline-flex items-center gap-1.5 px-3 xl:px-4 h-10 md:h-11 min-h-[44px] rounded-full bg-background-50/90 hover:bg-background-50 text-primary-700 font-heading font-bold text-xs xl:text-sm whitespace-nowrap cursor-pointer transition"
          >
            <i className="ri-restaurant-line"></i>
            メニューを見る
          </a>
          <a
            href={STORE.googleMapsSearchUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex items-center gap-1.5 px-3 xl:px-4 h-10 md:h-11 min-h-[44px] rounded-full bg-background-50/90 hover:bg-background-50 text-primary-700 font-heading font-bold text-xs xl:text-sm whitespace-nowrap cursor-pointer transition"
          >
            <i className="ri-map-2-line"></i>
            Googleマップ
          </a>
          <a
            href="#store"
            className="hidden sm:inline-flex items-center gap-2 px-4 md:px-5 h-10 md:h-11 min-h-[44px] rounded-full bg-primary-600 hover:bg-primary-700 text-background-50 dark:text-foreground-950 font-heading font-bold text-sm whitespace-nowrap cursor-pointer transition"
          >
            <i className="ri-anchor-line"></i>
            店舗情報を見る
          </a>
          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm font-heading font-bold text-foreground-900 whitespace-nowrap cursor-pointer flex items-center min-h-[44px]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={STORE.googleMapsSearchUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="text-sm font-heading font-bold text-primary-700 whitespace-nowrap cursor-pointer flex items-center gap-1.5 min-h-[44px]"
          >
            <i className="ri-map-2-line"></i>
            Googleマップで見る
          </a>
        </div>
      )}
    </header>
  );
}